import { jsx } from 'react/jsx-runtime';

/** ![maximizeIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNOCAzSDVhMiAyIDAgMCAwLTIgMnYzTTIxIDhWNWEyIDIgMCAwIDAtMi0yaC0zTTMgMTZ2M2EyIDIgMCAwIDAgMiAyaDNNMTYgMjFoM2EyIDIgMCAwIDAgMi0ydi0zIi8+PC9zdmc+) */
const maximizeIcon = /*#__PURE__*/jsx("path", {
  d: "M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"
});

export { maximizeIcon };
